module.exports = __webpack_public_path__ + "img/spritz.d9a30364.png";